<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '450px' }"
    header="Subcategoría Detalle"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <strong>NOMBRE DE SUBCATEGORÍA: </strong>
          <span class="p-invalid">*</span>
          <InputText
            v-model.trim="data_subservicio.descripcion"
            required="true"
            autofocus
          />
          <small class="p-invalid" v-if="errors.descripcion">{{
            errors.descripcion[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-12">
          <strong>CATEGORÍA: </strong><span class="p-invalid">*</span>
          <Dropdown
            v-model="data_subservicio.servicio.id"
            :options="servicios"
            optionLabel="descripcion"
            optionValue="id"
            placeholder="Seleccione una categoría..."
            :filter="true"
          />
          <small class="p-invalid" v-if="errors.servicio_id">{{
            errors.servicio_id[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-12">
          <strong>ESTADO: </strong><span class="p-invalid">*</span>
          <Dropdown
            v-model="data_subservicio.estado"
            :disabled="!data_subservicio.id"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span
                :class="'product-badge ' + claseEstado[slotProps.value.value]"
              >
                {{ slotProps.value.label }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="field">
        <label class="flex md:justify-content-start"
          ><strong>CAMPOS REQUERIDOS: </strong>
          <span class="p-invalid">*</span></label
        >
      </div>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
      />
      <Button
        :label="data_subservicio.id ? 'Actualizar' : 'Guardar'"
        :icon="data_subservicio.id ? 'pi pi-refresh' : 'pi pi-save'"
        class="p-button-info p-button-lg"
        @click="saveSubServicio"
        :loading="enviado"
      />
    </template>
  </Dialog>
</template>

<script>
import SubServicioService from "@/service/SubServicioService";
import ServicioService from "@/service/ServicioService";

export default {
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    subservicio: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  SubServicioService: null,
  ServicioService: null,
  data() {
    return {
      mostrarModal: this.show,
      data_subservicio: this.subservicio,
      servicios: [],
      enviado: false,
      estados: [
        { label: "INACTIVO", value: 0 },
        { label: "ACTIVO", value: 1 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
    };
  },
  created() {
    this.SubServicioService = new SubServicioService();
    this.ServicioService = new ServicioService();
  },
  mounted() {
    this.obtenerServicios();
  },
  methods: {
    ocultarDialog() {
      this.errors = {};
      this.mostrarModal = false;
      this.$emit("closeModal");
    },
    obtenerServicios() {
      this.ServicioService.getServicio().then((data) => {
        this.servicios = data.servicios;
      });
    },
    saveSubServicio() {
      this.errors = {};
      this.enviado = true;
      if (this.data_subservicio.id) {
        let subservicio_enviar = {
          id: this.data_subservicio.id,
          servicio_id: this.data_subservicio?.servicio?.id,
          descripcion: this.data_subservicio.descripcion,
          estado: this.data_subservicio.estado.value,
        };
        this.SubServicioService.updatedSubServicio(subservicio_enviar).then(
          (data) => {
            if (Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.errors = data.errors;
            } else {
              this.errors = {};
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 3000,
              });
              this.$emit("actualizarListado");
              this.ocultarDialog();
            }
            this.enviado = false;
          }
        );
      } else {
        let tmp = this.data_subservicio;
        this.data_subservicio = {
          servicio_id: this.data_subservicio?.servicio?.id,
          descripcion: this.data_subservicio.descripcion,
          estado: this.data_subservicio.estado.value,
        };
        this.SubServicioService.saveSubServicio(this.data_subservicio).then(
          (data) => {
            if (Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.errors = data.errors;
              this.data_subservicio = tmp;
            } else {
              this.errors = {};
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 10000,
              });
              this.$emit("actualizarListado", data.subservicio);
              this.ocultarDialog();
            }
            this.enviado = false;
          }
        );
      }
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    subservicio(val) {
      this.data_subservicio = val;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
